



































import Vue from "vue";
import Notebook from "./Notebook";
export default Notebook;
